import React, { useState } from 'react';
import { IconButton, Typography, Box } from '@mui/material';
import { AiFillHeart, AiOutlineHeart } from 'react-icons/ai';
import PropTypes from 'prop-types';
import styles from './LikeCounter.module.css';
import { apiFetch } from "../../../utils/api";

const LikeCounter = ({ id, initialLikes, isLiked, whiteBackground, className, isCreator = false }) => {
  const [liked, setLiked] = useState(isLiked);
  const [likeCount, setLikeCount] = useState(initialLikes);

  const handleLikeClick = async (e) => {
    e.stopPropagation();
    setLiked(!liked);
    setLikeCount(liked ? likeCount - 1 : likeCount + 1);
    console.log(`Liked item with ID: ${id}`);

    if (isCreator) {
      try {
        await apiFetch(`/api/creator/${id}/like`, {
          method: "POST",
        }, false, true);
      } catch (error) {
        console.error("❌ Failed to update like on server:", error);
      }
    } else {
      try {
        await apiFetch(`/api/memory/${id}/like`, {
          method: "POST",
        }, false, true);
      } catch (error) {
        console.error("❌ Failed to update like on server:", error);
      }
    }
  };

  return (
    <Box 
      className={`${styles.likeWrapper} ${whiteBackground ? styles.whiteBackground : ''} ${className || ''}`}
    >
      <IconButton className={styles.likeButton} onClick={handleLikeClick}>
        {liked ? (
          <AiFillHeart className={styles.likedIcon} />
        ) : (
          <AiOutlineHeart className={styles.unlikedIcon} />
        )}
      </IconButton>
      <Typography className={styles.likeCount}>{likeCount}</Typography>
    </Box>
  );
};

LikeCounter.propTypes = {
  id: PropTypes.string.isRequired,
  initialLikes: PropTypes.number.isRequired,
  isLiked: PropTypes.bool,
  whiteBackground: PropTypes.bool
};

LikeCounter.defaultProps = {
  isLiked: false,
  whiteBackground: false
};

export default LikeCounter;